import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core'
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms'
import { DatePipe } from '@angular/common'
import { Router } from '@angular/router'

import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap'
import { OrderPipe } from 'ngx-order-pipe'
import { ToastrService } from 'ngx-toastr'
import JSZip from 'jszip'
import { saveAs } from 'file-saver'

import { Arquivo } from 'src/app/models/arquivo.model'
import { Documento } from 'src/app/models/documento.model'
import { RegistroAtividade } from 'src/app/models/registroAtividade.model'
import { TipoAtividade } from 'src/app/models/tipoAtividade.model'
import { Usuario } from 'src/app/models/usuario.model'

import { ListUserService } from 'src/app/shared/listUser.service'
import { MensagemService } from 'src/app/shared/mesagem.service'
import { LoginService } from 'src/app/shared/login.service'

import { UploadService } from './upload.service'
import { Subscription } from 'rxjs'

@Component({
	selector: 'app-upload',
	templateUrl: './upload.component.html',
	styleUrls: ['./upload.component.scss'],
})
export class UploadComponent implements OnInit, OnDestroy {
	@ViewChild('fileInput', { static: false }) fileInput: ElementRef

	arquivos: Array<Arquivo> = []
	usuario: Usuario
	registroAtividade: RegistroAtividade
	documento: Documento

	infoMessage = { status: 0, message: '' }

	file: any
	fileUpload = { status: 'initial', message: 0, filePath: '' }
	profileForm: FormGroup
	modalRef: NgbModalRef
	isDisabled: boolean = true
	sucessRequest: boolean = false
	nameInputFile: string = ''
	error: string
	zipFile: JSZip

	// search
	_listFilter: string
	filtered: Array<Arquivo> = []
	filter = new FormControl('')

	// paginação
	page = 1
	pageSize = 50
	collectionSize: number
	pagefiltered: Array<Arquivo> = []
	order: string = 'DataCriacao'

	loginDisplay: boolean = false

	private subscriptions: Subscription[] = []

	constructor(
		private uploadService: UploadService,
		private listUserService: ListUserService,
		private loginService: LoginService,
		public messageService: MensagemService,
		private formBuilder: FormBuilder,
		private pipe: DatePipe,
		private orderPipe: OrderPipe,
		private toastrService: ToastrService,
		private router: Router
	) {
		this.orderPipe.transform(this.arquivos, this.order)
		this.orderPipe.transform(this.pagefiltered, this.order)
		this.createProfileForm()
	}

	ngOnInit(): void {
		this.subscriptions.push(
			this.loginService.user$.subscribe((user) => {
				this.usuario = user
				this.loginDisplay = !!user
				this.getFiles()
			}),
			this.loginService.error$.subscribe((error) => {
				this.infoMessage.message = error || ''
			})
		)

		this.listUserService.listarUser()
		this.messageService.clear()
	}

	get listFilter(): string {
		return this._listFilter
	}

	set listFilter(value: string) {
		this.filtered = this.arquivos
		this._listFilter = value
		this.filtered = this.listFilter ? this.onFilter(this.listFilter) : this.arquivos
		this.collectionSize = this.filtered.length
		this.pagefiltered = this.filtered.sort((a, b) => {
			var dataInicial = new Date(a.DataCriacao).getTime() / 1000
			var dataFinal = new Date(b.DataCriacao).getTime() / 1000
			return dataInicial > dataFinal ? -1 : 1
		})
		this.refreshPage()
	}

	onFilter(text: string): Array<Arquivo> {
		return this.arquivos.filter((arquivo) => {
			const term = text.toLowerCase()
			return (
				arquivo.Nome.toLowerCase().includes(term) ||
				// @ts-ignore: Object is possibly 'null'.
				this.pipe.transform(arquivo.DataCriacao, 'dd-MM-yyyy').includes(term)
			)
		})
	}

	refreshPage() {
		this.pagefiltered = this.listFilter
			? this.filtered
					.map((arquivo, i) => ({ index: i + 1, ...arquivo }))
					.slice((this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize)
			: this.arquivos
					.map((arquivo, i) => ({ index: i + 1, ...arquivo }))
					.slice((this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize)
	}

	cleanFiltered() {
		this.collectionSize = this.arquivos.length
		this.listFilter = ''
		this.refreshPage()
	}

	getFiles() {
		if (this.usuario) {
			const empresas = this.usuario.grupo.empresas.map((empresa) => empresa.codigo)
			if (empresas) {
				this.uploadService.getFiles(empresas).subscribe((res) => {
					this.infoMessage.status = 2
					if (res.status == 'NOK') {
						this.showAlertInfo(res.mensagem)
					} else {
						if (res._count == 0 || res.arquivos!.length == 0) {
							this.infoMessage = { status: 1, message: 'Não existem arquivos processados para esse grupo!' }
						} else {
							this.infoMessage.status = 3
							this.arquivos = res.arquivos
							this.listFilter
							this.cleanFiltered()
						}
					}
				})
			}
		}
	}

	nameFileFormatedTable(nomeFile: string) {
		var splitExt = nomeFile.split('.')
		var splitName = splitExt[0].split('_')
		var splitNamePOP = splitName.pop()
		var qt = splitName.length

		if (qt < 3) {
			return nomeFile
		}

		var codigo = splitName[0]
		var anoMes = splitName[qt - 1]
		var extensao = splitExt[1]

		var processos = splitName.slice(1, qt - 1)

		return `${codigo}_${processos.join('_')}_${anoMes}.${extensao}`
	}

	nameFileFormated(file: any) {
		var slip = file.name.split('.')
		var splitName = slip[0].split('_')
		var splitExt = slip[1]
		var qt = splitName.length

		if (qt < 3) {
			return file
		}

		var codigo = splitName[0]
		var anoMes = splitName[qt - 1]
		var extensao = splitExt

		var processos = splitName.slice(1, qt - 1)

		file['nome'] = `${codigo}_${processos.join('_')}_${anoMes}.${extensao}`
		file['tipo'] = `${extensao}`
		this.file = file
	}

	onSelectedFile(event) {
		this.messageService.clear()
		this.nameFileFormated(event.target.files[0])

		this.nameInputFile = this.file.nome

		if (this.file.size === 0) {
			this.showErrorCreate('O arquivo está sem conteúdo.')
			this.isDisabled = true
		} else {
			switch (this.file.tipo) {
				case 'txt':
					let files: any
					this.uploadCheckedCaracteres(this.file).then((res) => {
						files = res
						if (files!.name.match(/^\d{1,4}\_.+\_(?![a-zA-Z])(\d{1,6})\.txt$/)) {
							this.isDisabled = false
							this.profileForm.get('profile')?.setValue(files)
						} else {
							this.showErrorCreate(`O arquivo - ${this.file.nome} está com sua descrição fora do padrão esperado codigo_processo_anoMes`)
							this.resetForm()
						}
					})
					break
				case 'xlsx':
					if (this.file.nome.match(/^\d{1,4}\_.+\_(?![a-zA-Z])(\d{1,6})\.xlsx$/)) {
						this.isDisabled = false
						this.profileForm.get('profile')?.setValue(this.file)
					} else {
						this.showErrorCreate(`O arquivo - ${this.file.nome}, está com sua descrição fora do padrão esperado codigo_processo_anoMes`)
						this.resetForm()
					}
					break
				case 'xls':
					if (this.file.nome.match(/^\d{1,4}\_.+\_(?![a-zA-Z])(\d{1,6})\.xls$/)) {
						this.isDisabled = false
						this.profileForm.get('profile')?.setValue(this.file)
					} else {
						this.showErrorCreate(`O arquivo - ${this.file.nome}, está com sua descrição fora do padrão esperado codigo_processo_anoMes`)
						this.resetForm()
					}
					break
				default:
					this.isDisabled = true
					break
			}
		}
	}

	clearInputFile() {
		this.fileInput.nativeElement.value = ''
	}

	resetForm() {
		this.isDisabled = true
		this.nameInputFile = ''
		this.profileForm.reset()
		this.clearInputFile()
	}

	createProfileForm() {
		this.profileForm = this.formBuilder.group({
			name: ['', [Validators.required]],
			profile: ['', [Validators.required]],
		})
	}

	onCreate() {
		this.sucessRequest = false
		const formData = new FormData()
		formData.append('name', this.profileForm.get('name')?.value)
		formData.append('profile', this.profileForm.get('profile')?.value)

		const file = this.profileForm.get('profile')?.value
		this.getBase64(file).then((res) => {
			const documentoPart: any[] = file.name.split('_', file.length)
			const nomeArquivo = file.name.substring(file.name.indexOf('_') + 1, file.name.lastIndexOf('_'))
			const codigoEmpresa = this.usuario.grupo.empresas.map((emp) => emp.codigo.toUpperCase().trim())
			const codigoFiltrado = codigoEmpresa.includes(documentoPart[0].toUpperCase())
			const nomeProcesso = this.usuario.grupo.enviarProcessos.map((proc) => proc.nome.toLowerCase().trim())
			const nomeProcessoFiltrado = nomeProcesso.includes(nomeArquivo.toLowerCase().trim())
			this.registroAtividade = new RegistroAtividade()

			if (codigoFiltrado && nomeProcessoFiltrado) {
				this.isDisabled = true
				this.documento = {
					nomeArquivo: file.name,
					data: `${new Date().getDate().toString()}/${new Date().getMonth() + 1}/${new Date().getFullYear().toString()} ${new Date()
						.getHours()
						.toString()}:${new Date().getMinutes().toString()}:${new Date().getSeconds().toString()}`,
					tipo: 'upload',
					processo: nomeArquivo,
					grupo: this.usuario.grupo.nome,
					usuario: this.usuario.nome,
					conteudoBase64: res,
				}
				this.uploadService.enviarDocumento(formData, this.documento).subscribe(
					(res) => {
						this.fileUpload = res
						if (res.name === 'TimeoutError' || res.name === '') {
							this.showErrorCreate(`Erro ao tentar fazer o envio do arquivo! Mensagem: ${res.message}`)
						}
						if (res === 201) {
							this.messageService.clear()
							this.showSucessCreate(`Arquivo ${this.file.nome} enviado com sucesso.`)
							this.resetForm()
							this.ngOnInit()
							this.sucessRequest = true
						}
					},
					(error) => {
						const erro: number = error || error.messsage
						this.showErrorCreate(`Erro ao tentar fazer o envio do arquivo! Mensagem: ${erro}`)
					}
				)
			} else if (codigoFiltrado === false) {
				if (codigoEmpresa.includes(documentoPart[0].toUpperCase().trim() || documentoPart[0].toLowerCase().trim())) {
					this.showErrorCreate(`Erro ao tentar enviar o arquivo, empresa de código: ${documentoPart[0]}, verifique se o nome está maiúsculo.`)
				} else {
					this.showErrorCreate(
						`Empresa de código: ${documentoPart[0]}, não cadastrada para o grupo  deste usuário, as empresas cadastradas são: ${codigoEmpresa}`
					)
				}
			} else if (nomeProcessoFiltrado === false) {
				this.showErrorCreate(`Nome processo: ${nomeArquivo}, Processo não cadastrado para o grupo de empresas deste usuário.`)
			}
		})
	}

	detectEncoding(file): Promise<string> {
		// ISO-8859-1 como padrão - UTF-8 é exceção
		// Detecta UTF-8 se encontrar sequências válidas de multi-byte
		const checkSize = 10000 // Verifica mais bytes para encontrar caracteres especiais
		
		const hasUTF8Sequence = (arr: Uint8Array) => {
			for (let i = 0; i < arr.length - 1; i++) {
				const byte = arr[i]
				// Sequência UTF-8 de 2 bytes: 0xC0-0xDF seguido de 0x80-0xBF
				if (byte >= 0xC0 && byte <= 0xDF && arr[i + 1] >= 0x80 && arr[i + 1] <= 0xBF) {
					console.log(`Sequência UTF-8 (2 bytes) na posição ${i}: [${byte.toString(16)}, ${arr[i + 1].toString(16)}]`)
					return true
				}
				// Sequência UTF-8 de 3 bytes: 0xE0-0xEF seguido de 2x 0x80-0xBF
				if (i < arr.length - 2 && byte >= 0xE0 && byte <= 0xEF && 
					arr[i + 1] >= 0x80 && arr[i + 1] <= 0xBF && 
					arr[i + 2] >= 0x80 && arr[i + 2] <= 0xBF) {
					console.log(`Sequência UTF-8 (3 bytes) na posição ${i}: [${byte.toString(16)}, ${arr[i + 1].toString(16)}, ${arr[i + 2].toString(16)}]`)
					return true
				}
			}
			return false
		}

		return new Promise((resolve) => {
			console.log('=== DETECT ENCODING ===')
			console.log('Arquivo:', file.name || file.nome)
			console.log('Tamanho:', file.size, 'bytes')
			const reader = new FileReader()
			reader.onload = () => {
				const arr = new Uint8Array(reader.result as ArrayBuffer)
				console.log('Primeiros 50 bytes:', Array.from(arr.slice(0, 50)).map(b => b.toString(16).padStart(2, '0')).join(' '))
				
				// Verifica BOM UTF-8 (EF BB BF)
				if (arr[0] === 0xEF && arr[1] === 0xBB && arr[2] === 0xBF) {
					console.log('BOM UTF-8 detectado!')
					resolve('UTF-8')
					return
				}
				
				if (hasUTF8Sequence(arr)) {
					console.log('Encoding detectado: UTF-8 (sequência encontrada)')
					resolve('UTF-8')
				} else {
					console.log('Encoding detectado: ISO-8859-1 (padrão)')
					resolve('ISO-8859-1')
				}
			}
			// Lê o arquivo inteiro se for pequeno, senão lê uma amostra maior
			reader.readAsArrayBuffer(file.slice(0, Math.min(checkSize, file.size)))
		})
	}

	uploadCheckedCaracteres(file): Promise<File> {
		const parsed: string[] = []
		let blob: any = null
		if (file) {
			return new Promise(async (resolve, reject) => {
				const encoding = await this.detectEncoding(file)
				console.log('=== UPLOAD CHECKED CARACTERES ===')
				console.log('Encoding usado:', encoding)
				const fileReader = new FileReader()
				fileReader.onload = (e) => {
					const line = fileReader.result!.toString()
					console.log('Primeiras 3 linhas do conteúdo:')
					console.log(line.split('\n').slice(0, 3).join('\n'))
					console.log('Últimas 3 linhas do conteúdo:')
					console.log(line.split('\n').slice(-3).join('\n'))
					const removeAccent = line!
						.normalize('NFD')
						.replace(/[\u0300-\u036f]/gi, '')
						.toString()
					console.log('Após normalização - Últimas 3 linhas:')
					console.log(removeAccent.split('\n').slice(-3).join('\n'))
					parsed.push(removeAccent)
					blob = new File(parsed, file!.nome)
					resolve(blob)
				}
				fileReader.readAsText(file, encoding)
				fileReader.onerror = (error) => reject(error)
			})
		} else {
			return file
		}
	}

	getBase64(file): Promise<string> {
		const doc: any[] = file.name.split('_', file.length)
		console.log('=== GET BASE64 DEBUG ===')
		console.log('Nome do arquivo:', file.name)
		console.log('Tamanho do arquivo:', file.size)
		if (doc.length >= 3) {
			return new Promise((resolve, reject) => {
				const reader = new FileReader()
				reader.onload = () => {
					const line = reader.result?.toString()
					let encoded = line!.toString().replace(/^data:(.*;base64,)?/, '')
					if (encoded!.length % 4 > 0) {
						encoded += '='.repeat(4 - (encoded!.length % 4))
					}
					console.log('Base64 COMPLETO:')
					console.log(encoded)
					// Decodifica para verificar o conteúdo
					try {
						const decoded = atob(encoded)
						console.log('Conteúdo decodificado COMPLETO:')
						console.log(decoded)
					} catch (e) {
						console.log('Erro ao decodificar base64:', e)
					}
					resolve(encoded)
				}
				reader.readAsDataURL(file)
				reader.onerror = (error) => reject(error)
			})
		} else {
			return file
		}
	}

	getCompactados(filename, data) {
		this.zipFile.file(filename, data, { binary: true })
	}

	getLogDownload(arquivo: Arquivo) {
		const registroAtividade = new RegistroAtividade()
		this.registroAtividade = {
			tipo: TipoAtividade.download,
			nomeProcesso: arquivo.Nome.substring(arquivo.Nome.indexOf('_') + 1, arquivo.Nome.lastIndexOf('_')),
			idGrupo: this.usuario.grupo.id,
			nomeGrupo: this.usuario.grupo.nome,
			usuario: this.usuario,
			nomeArquivo: arquivo.Nome,
			dataHora: new Date(),
			nomeArquivoEnviado: '',
		}
	}

	download(arquivo: Arquivo) {
		const registroAtividade = new RegistroAtividade()
		this.registroAtividade = {
			tipo: TipoAtividade.download,
			nomeProcesso: arquivo.Nome.substring(arquivo.Nome.indexOf('_') + 1, arquivo.Nome.lastIndexOf('_')),
			idGrupo: this.usuario.grupo.id,
			nomeGrupo: this.usuario.grupo.nome,
			usuario: this.usuario,
			nomeArquivo: arquivo.Nome,
			dataHora: new Date(),
			nomeArquivoEnviado: '',
		}
	}

	downloadZip(event) {
		this.zipFile = new JSZip()
		const filename = 'arquivos.zip'
		const arquivos = this.pagefiltered.map((blobFile) => blobFile)
		let data: string
		this.pagefiltered.forEach((obj) => {
			let xhr = new XMLHttpRequest()
			xhr.open('GET', obj.Url, false)
			xhr.overrideMimeType('application/octet-streamplain; charset=utf-8')
			xhr.onload = function (e) {
				if (this.status === 200) data = this.responseText
			}
			xhr.send()
			this.getCompactados(obj.Nome, data)
			this.getLogDownload(obj)
		})

		this.zipFile.generateAsync({ type: 'blob' }).then(function (file) {
			saveAs(file, filename)
		})
	}

	showSucessCreate(msg: any) {
		this.toastrService.success(msg, 'PTA - Portal de transferência de arquivo', {
			timeOut: 2000,
			closeButton: true,
		})
		this.router.navigateByUrl('/upload')
		this.getFiles()
		this.resetForm()
	}

	showErrorCreate(msg: any) {
		this.toastrService.error(msg, 'PTA - Portal de transferência de arquivo', {
			timeOut: 2000,
			closeButton: true,
		})
		this.router.navigateByUrl('/upload')
		this.getFiles()
		this.resetForm()
	}

	showAlertInfo(msg: any) {
		this.toastrService.error(`${msg} - Erro ao executar a chamada, por favor tente mais tarde!`, 'PTA - Portal de transferência de arquivo', {
			timeOut: 2000,
			closeButton: true,
		})
		this.router.navigateByUrl('/upload')
		this.resetForm()
	}

	ngOnDestroy(): void {
		this.subscriptions.forEach((sub) => sub.unsubscribe())
	}
}
